import { render, staticRenderFns } from "./PolicyDeleteModal.vue?vue&type=template&id=bfbfb754&scoped=true"
import script from "./PolicyDeleteModal.vue?vue&type=script&lang=js"
export * from "./PolicyDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyDeleteModal.vue?vue&type=style&index=0&id=bfbfb754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbfb754",
  null
  
)

export default component.exports